import { Suspense, lazy, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { trackPageView } from './lib/analytics.js';
import AnalyticsProviders from './components/AnalyticsProviders.jsx';

const Home      = lazy(() => import('./pages/Home.jsx'));
const Features  = lazy(() => import('./pages/Features.jsx'));
const Pricing   = lazy(() => import('./pages/Pricing.jsx'));
const FreeTrial = lazy(() => import('./pages/FreeTrial.jsx'));
const About     = lazy(() => import('./pages/About.jsx'));
const Privacy   = lazy(() => import('./pages/Privacy.jsx'));
const Terms     = lazy(() => import('./pages/Terms.jsx'));
const DPA       = lazy(() => import('./pages/DPA.jsx'));
const Training                    = lazy(() => import('./pages/Training.jsx'));
const TrainingRegister            = lazy(() => import('./pages/TrainingRegister.jsx'));
const TrainingCreateParty         = lazy(() => import('./pages/TrainingCreateParty.jsx'));
const TrainingCreateProduct       = lazy(() => import('./pages/TrainingCreateProduct.jsx'));
const TrainingCreateService       = lazy(() => import('./pages/TrainingCreateService.jsx'));
const TrainingCreateSalesInvoice  = lazy(() => import('./pages/TrainingCreateSalesInvoice.jsx'));
const TrainingCreateAccount       = lazy(() => import('./pages/TrainingCreateAccount.jsx'));
const TrainingCreateCreditDebitNote = lazy(() => import('./pages/TrainingCreateCreditDebitNote.jsx'));
const TrainingRecordPayment       = lazy(() => import('./pages/TrainingRecordPayment.jsx'));
const TrainingFileGSTR            = lazy(() => import('./pages/TrainingFileGSTR.jsx'));
const TrainingChangeInvoiceTemplate = lazy(() => import('./pages/TrainingChangeInvoiceTemplate.jsx'))

export default function App() {
  const location = useLocation();

  useEffect(() => {
    trackPageView({ path: location.pathname, title: document.title });
  }, [location.pathname]);

  return (
    <>
      <AnalyticsProviders />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/"           element={<Home />} />
          <Route path="/features"   element={<Features />} />
          <Route path="/pricing"    element={<Pricing />} />
          <Route path="/free-trial" element={<FreeTrial />} />
          <Route path="/about"      element={<About />} />
          <Route path="/privacy"    element={<Privacy />} />
          <Route path="/terms"      element={<Terms />} />
          <Route path="/dpa"        element={<DPA />} />
          <Route path="/training"                            element={<Training />} />
          <Route path="/training/how-to-register"             element={<TrainingRegister />} />
          <Route path="/training/how-to-create-party"         element={<TrainingCreateParty />} />
          <Route path="/training/how-to-create-product"       element={<TrainingCreateProduct />} />
          <Route path="/training/how-to-create-service"       element={<TrainingCreateService />} />
          <Route path="/training/how-to-create-sales-invoice" element={<TrainingCreateSalesInvoice />} />
          <Route path="/training/how-to-create-account"       element={<TrainingCreateAccount />} />
          <Route path="/training/how-to-create-credit-debit-note" element={<TrainingCreateCreditDebitNote />} />
          <Route path="/training/how-to-record-payment"       element={<TrainingRecordPayment />} />
          <Route path="/training/how-to-file-gstr"             element={<TrainingFileGSTR />} />
          <Route path="/training/how-to-change-create-invoice-template"             element={<TrainingChangeInvoiceTemplate />} />
          <Route path="*"           element={<Home />} />
        </Routes>
      </Suspense>
    </>
  );
}
